<template>
  <div style="text-align: center; margin-top:20px">
    <a-spin></a-spin>
  </div>
</template>